import { footerLinks } from '@/pages/home/mocks/data';

export default function Footer() {
  const handleNavClick = (e: React.MouseEvent<HTMLAnchorElement>, id: string) => {
    e.preventDefault();
    const el = document.getElementById(id);
    if (el) {
      el.scrollIntoView({ behavior: 'smooth' });
    }
  };

  return (
    <footer id="footer" className="bg-foreground-900 text-white">
      <div className="max-w-7xl mx-auto px-4 md:px-6 py-14 md:py-16">
        <div className="grid grid-cols-2 md:grid-cols-4 gap-8 mb-10">
          <div>
            <span className="text-xl font-heading text-primary-400 mb-4 block">51吃瓜</span>
            <p className="text-xs text-foreground-300 leading-relaxed">
              全网最全娱乐八卦黑料聚合平台。支持51吃瓜轻量版与51吃瓜app下载，安卓版、iOS版多端畅享。
            </p>
          </div>
          {footerLinks.sections.map((section) => (
            <div key={section.title}>
              <h4 className="text-sm font-semibold text-white mb-3">{section.title}</h4>
              <ul className="space-y-2">
                {section.links.map((link) => (
                  <li key={link}>
                    <a
                      href="#footer"
                      className="text-xs text-foreground-300 hover:text-primary-400 transition-colors cursor-pointer"
                    >
                      {link}
                    </a>
                  </li>
                ))}
              </ul>
            </div>
          ))}
        </div>

        <div className="border-t border-foreground-700 pt-8 mb-8">
          <h4 className="text-sm font-semibold text-white mb-4">合作伙伴</h4>
          <div className="flex flex-wrap gap-4">
            <span className="text-xs text-foreground-400">暂无合作伙伴信息</span>
          </div>
        </div>

        <div className="text-center text-xs text-foreground-400 leading-relaxed">
          <p>{footerLinks.bottom}</p>
        </div>
      </div>
    </footer>
  );
}